import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import cytoscape from 'cytoscape';
import automove from 'cytoscape-automove';

import graphJson from 'src/app/graph.json';

import d3Force from 'cytoscape-d3-force';
d3Force(cytoscape);

import dblclick from 'cytoscape-dblclick';
cytoscape.use(dblclick);

import contextMenus from 'cytoscape-context-menus';


cytoscape.use(contextMenus);


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css', './mediaquerie.css']
})
export class AppComponent {
  title = 'Demo Term Graph';
  // account: Account | null = null;
  cy: any;


  ctxMenu; //variabile context menu
  contextMenu; //variabile context menu  

  defaults;
  isDisplay: boolean = false;
  isDisplayA: boolean = false;
  isDisplayC: boolean = false;
  isDisplayS: boolean = false;
  isDisplayN: boolean = false;
  selezione;
  nodoS;
  nodiSelezionati: any[] = [];
  nodoCliccato;
  clicked: boolean = false;

  idPersonal: string;
  currentEle: string;

  linkD: number = 150;
  linkStep: number = 100;
  layoutProva;
  layout;
  eleStyle: any;

  zoomStep: number = 0.1;
  zoomCurrent: number = 1;

  // fixForm: FormGroup;
  fix: boolean = true;

  zoomNodoForm: FormGroup;
  trattato;
  searchText = '';
  // trattati: Trattato[];
  trattati: any[];
  trattatiTermini: any[];

  specificTermsShown: boolean = false;
  sharedTermsShown: boolean = false;

  highlightedEle;

  ngOnInit(): void {
    const that = this; //toglie errore undefined 
    // ORDINE ALFABETICO TRATTATI  
    this.trattati = graphJson[0].nodes.sort(function (a, b) {
      var nameA = a.data.label.toUpperCase(); // ignore upper and lowercase
      var nameB = b.data.label.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    });

    // mostro solo trattati
    this.trattati = graphJson[0].nodes.filter(el => {
      if (el.data.type == 'TRACTATE') {
        return el.data.label;
      }
    })

    // ORDINE ALFABETICO TERMINI
    this.trattatiTermini = graphJson[0].nodes.sort(function (a, b) {
      var nameA = a.data.label.toUpperCase(); // ignore upper and lowercase
      var nameB = b.data.label.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    });

    // ARRAY TERMINI DA RIVEDERE PERCHé BISOGNA INSERIRE LA CLASSE CORRISPONDENTE DEI TERMINI
    this.trattatiTermini = graphJson[
      0].nodes.filter(el => {
        if (el.data.type == 'TERM') {
          return el.data.label;
        }
        // return el.data.id ;
      })

    this.zoomNodoForm = new FormGroup({
      'idPersonal': new FormControl(null)
    });

    this.cy = cytoscape({
      container: document.getElementById('cy'),
      elements: graphJson[0],
      minZoom: 0.2,
      maxZoom: 2.0,
      zoomingEnabled: true,
      userZoomingEnabled: true,
      zoom: this.zoomCurrent,

      layout: {
        name: 'cose',
        fit: true,
        zoom: 0.5,
        refresh: 20,
        componentSpacing: 100,
        idealEdgeLength: function (edge) { return 150; },
        nodeRepulsion: function (node) { return 20; },
        edgeElasticity: function (edge) { return 30; },
        nodeOverlap: 20,
        padding: 30,
        randomize: false,
        nestingFactor: 5,
        gravity: 80,
        numIter: 1000,
        initialTemp: 200,
        coolingFactor: 0.95,
        minTemp: 1.0
      },
      wheelSensitivity: 0.05,

      // style: styleJson[0],
      style: [
        {
          selector: 'node',
          style: {
            'label': 'data(label)'
          }
        },
        {
          selector: 'edge',
          style: {
            'target-arrow-shape': 'triangle',
            'curve-style': 'straight',
            'opacity': 0.3
          }
        },
        {
          selector: 'node.highlight',
          style: {
            'overlay-color': '#faee46',
            'overlay-opacity': 0.5,
            'overlay-padding': 0.2,
            'text-outline-color': '#faee46',
            'text-outline-width': 2
          }
        },
        {
          selector: '[type="TERM"][!specific]',
          style: {
            'shape': 'rectangle',
            'background-color': '#C4BDAC',
            // 'background-color': '#D3C4BE',
            'border-color': '#625B6F',
            'border-style': 'solid',
            'border-width': 2,

          }
        },
        {
          selector: '[type="TERM"][!specific][?common]',
          style: {
            // 'shape':'star',
            'shape': 'triangle',
            'border-color': 'black',
            'border-style': 'solid',
            'border-width': 2,
            'background-color': 'white',
            'background-opacity': 0.5
          }
        },
        {
          selector: '[type="TRACTATE"]',
          style: {
            'z-index': 1
          }
        },
        {
          selector: 'edge.highlight',
          style: {
            'overlay-color': '#faee46',
            'overlay-opacity': 0.5,
            'overlay-padding': '2px',
            'target-arrow-color': '#faee46'
          }
        },
        // Berakhot
        {
          selector: '[id="1"]',
          style: {
            'background-color': 'red',
            'width': '50',
            'height': '50',
            'text-halign': 'center',
            'text-valign': 'center',
            'text-background-color': 'red',
            'text-background-padding': '2px',
            'text-background-opacity': 1
          }
        },
        {
          selector: '[belongsTo=1][!common]',
          style: {
            'border-color': 'red',
            'border-style': 'solid',
            'border-width': 2,
            'background-color': 'white',
            'background-opacity': 0.5
          }
        },
        // Ta'anit
        {
          selector: '[id="4"]',
          style: {
            'background-color': '#ffcc00',
            'width': '50',
            'height': '50',
            'text-halign': 'center',
            'text-valign': 'center',
            'text-background-color': '#ffcc00',
            'text-background-padding': '2px',
            'text-background-opacity': 1
          }
        },
        {
          selector: '[belongsTo=4][!common]',
          style: {
            'border-color': '#ffcc00',
            'border-style': 'solid',
            'border-width': 2,
            'background-color': 'white',
            'background-opacity': 0.5
          }
        },

        // Betza
        {
          selector: '[id="6"]',
          style: {
            'background-color': '#ff00ff',
            'width': '50',
            'height': '50',
            'text-halign': 'center',
            'text-valign': 'center',
            'text-background-color': '#ff00ff',
            'text-background-padding': '2px',
            'text-background-opacity': 1
          }
        },
        {
          selector: '[belongsTo=6][!common]',
          style: {
            'border-color': '#ff00ff',
            'border-style': 'solid',
            'border-width': 2,
            'background-color': 'white',
            'background-opacity': 0.5
          }
        },
        // Sukka
        {
          selector: '[id="8"]',
          style: {
            'background-color': '#b3d9ff',
            'width': '50',
            'height': '50',
            'text-halign': 'center',
            'text-valign': 'center',
            'text-background-color': '#b3d9ff',
            'text-background-padding': '2px',
            'text-background-opacity': 1
          }
        },
        {
          selector: '[belongsTo=8][!common]',
          style: {
            'border-color': '#b3d9ff',
            'border-style': 'solid',
            'border-width': 2,
            'background-color': 'white',
            'background-opacity': 0.5
          }
        },

        // Meghilla 
        {
          selector: '[id="10"]',
          style: {
            'background-color': '#ff9900',
            'width': '50',
            'height': '50',
            'text-halign': 'center',
            'text-valign': 'center',
            'text-background-color': '#ff9900',
            'text-background-padding': '2px',
            'text-background-opacity': 1
          }
        },
        {
          selector: '[belongsTo=10][!common]',
          style: {
            'border-color': '#ff9900',
            'border-style': 'solid',
            'border-width': 2,
            'background-color': 'white',
            'background-opacity': 0.5
          }
        },
        // Qiddushin
        {
          selector: '[id="12"]',
          style: {
            'background-color': '#00cc00',
            'width': '50',
            'height': '50',
            'text-halign': 'center',
            'text-valign': 'center',
            'text-background-color': '#00cc00',
            'text-background-padding': '2px',
            'text-background-opacity': 1
          }
        },
        {
          selector: '[belongsTo=12][!common]',
          style: {
            'border-color': '#00cc00',
            'border-style': 'solid',
            'border-width': 2,
            'background-color': 'white',
            'background-opacity': 0.5
          }
        },
        // Rosh HaShananh
        {
          selector: '[id="14"]',
          style: {
            'background-color': '#0099ff',
            'width': '50',
            'height': '50',
            'text-halign': 'center',
            'text-valign': 'center',
            'text-background-color': '#0099ff',
            'text-background-padding': '2px',
            'text-background-opacity': 1
          }
        },
        {
          selector: '[belongsTo=14][!common]',
          style: {
            'border-color': '#0099ff',
            'border-style': 'solid',
            'border-width': 2,
            'background-color': 'white',
            'background-opacity': 0.5
          }
        },
        // Chaghiga
        {
          selector: '[id="16"]',
          style: {
            'background-color': '#b366ff',
            'width': '50',
            'height': '50',
            'text-halign': 'center',
            'text-valign': 'center',
            'text-background-color': '#b366ff',
            'text-background-padding': '2px',
            'text-background-opacity': 1
          }
        },
        {
          selector: '[belongsTo=16][!common]',
          style: {
            'border-color': '#b366ff',
            'border-style': 'solid',
            'border-width': 2,
            'background-color': 'white',
            'background-opacity': 0.5
          }
        }
      ],
    });

    // estensione dbclick
    this.cy.dblclick();

    this.highlightedEle = this.cy.elements(':active');
    //estensione d3Force

    this.defaults = {
      name: 'd3-force',
      zoom: 0.5,
      fit: false,
      animate: true,
      maxIterations: 0, // max iterations before the layout will bail out
      maxSimulationTime: 0, // max length in ms to run the layout
      ungrabifyWhileSimulating: false,
      // d3-force specific 
      alpha: 0.9,
      alphaMin: 0.15,
      alphaDecay: 0.03,
      velocityDecay: 0.3,
      fixedAfterDragging: true,
      linkId: function id(d) {
        return d.id;
      },
      collideRadius: 30, // sets the radius accessor to the specified number or function
      // collideStrength: 0.7, // sets the force strength to the specified number in the range [0,1]
      collideIterations: 10,
      linkDistance: this.linkD,
      // linkDistance: 150,
      manyBodyStrength: -600,
      ready: function () { },
      stop: function () { },
      manyBodyDistanceMin: 300,
      manyBodyDistanceMax: 5000,
      randomize: false,
      infinite: true,
      xStrength: 0.0001, // sets the strength accessor to the specified number or function
      xX: 1000, // sets the x-coordinate accessor to the specified number or function
      yStrength: 0.0001, // sets the strength accessor to the specified number or function
      yY: 1000,
      radialStrength: 0.001, // sets the strength accessor to the specified number or function
      radialRadius: [360],// sets the circle radius to the specified number or function
      radialX: 0.1, // sets the x-coordinate of the circle center to the specified number
      radialY: 0.1
    }
    cytoscape.use(d3Force);
    this.layout = this.cy.layout(this.defaults);
    // this.layout.run();
    this.layout.stop();
    // estensione context menu
    this.ctxMenu = {
      evtType: 'cxttap',
      menuItems: [
        {
          id: 'mostraTuttiTermini',
          content: 'mostra tutti termini',
          tooltipText: 'mostra tutti termini',
          selector: 'node[type="TRACTATE"]',
          onClickFunction: function (event) {
            let target = event.target;
            that.layout.run();
            target.connectedEdges().targets().style("display", "element");
            target.connectedEdges().style("display", "element");
            let terminiVisibili = that.cy.nodes(':visible');
            for (var i = 0; i < terminiVisibili.length; i++) {
              that.nodiSelezionati.push(terminiVisibili[i].data().id);
            }
          },
          disabled: false
        },
        {
          id: 'mostraTerminiPeculiari',
          content: 'mostra termini peculiari',
          tooltipText: 'mostra termini peculiari',
          selector: 'node[type="TRACTATE"]',
          onClickFunction: function (event) {
            let target = event.target;
            that.layout.run();
            if (target.connectedEdges().targets().style("display", "none")) {
              for (var i = 0; i < target.connectedEdges().targets().length; i++) {
                let nodoS = target.connectedEdges().targets()[i];
                if (nodoS.indegree() == 1) {
                  nodoS.style("display", "element");
                  target.connectedEdges().style("display", "element");
                }
              }
            }
            that.nodiSelezionati = [];
            let terminiVisibili = that.cy.nodes(':visible');
            for (var i = 0; i < terminiVisibili.length; i++) {
              that.nodiSelezionati.push(terminiVisibili[i].data().id);
            }
          },
          disabled: false
        },
        {
          id: 'mostraTerminiCondivisiAltaRilevanza',
          content: 'mostra termini condivisi ad alta rilevanza',
          tooltipText: 'mostra termini condivisi ad alta rilevanza',
          selector: 'node[type="TRACTATE"]',
          onClickFunction: function (event) {
            let target = event.target;
            that.layout.run();
            if (target.connectedEdges().targets().style("display", "none")) {
              for (var i = 0; i < target.connectedEdges().targets().length; i++) {
                let nodoS = target.connectedEdges().targets()[i];
                if (nodoS.data().specific == false && nodoS.data().common == false) {
                  nodoS.style("display", "element");
                  target.connectedEdges().style("display", "element");
                }
              }
            }
            that.nodiSelezionati = [];
            let terminiVisibili = that.cy.nodes(':visible');
            for (var i = 0; i < terminiVisibili.length; i++) {
              that.nodiSelezionati.push(terminiVisibili[i].data().id);
            }
          },
          disabled: false
        },
        {
          id: 'mostraTerminiCondivisiAltaFrequenza',
          content: 'mostra termini condivisi ad alta frequenza',
          tooltipText: 'mostra termini condivisi ad alta frequenza',
          selector: 'node[type="TRACTATE"]',
          onClickFunction: function (event) {
            let target = event.target;
            that.layout.run();
            if (target.connectedEdges().targets().style("display", "none")) {
              for (var i = 0; i < target.connectedEdges().targets().length; i++) {
                let nodoS = target.connectedEdges().targets()[i];
                if (nodoS.data().common == true) {
                  nodoS.style("display", "element");
                  target.connectedEdges().style("display", "element");
                }
              }
            }
            that.nodiSelezionati = [];
            let terminiVisibili = that.cy.nodes(':visible');
            for (var i = 0; i < terminiVisibili.length; i++) {
              that.nodiSelezionati.push(terminiVisibili[i].data().id);
            }
          },
          disabled: false
        },
        {
          id: 'nascondiTermini',
          content: 'nascondi tutti i termini',
          tooltipText: 'nascondi tutti i termini',
          selector: 'node[type="TRACTATE"]',
          onClickFunction: function (event) {
            let target = event.target;
            target.connectedEdges().targets().style("display", "none");
            target.connectedEdges().style("display", "none");
            that.nodiSelezionati = [];
            let terminiVisibili = that.cy.nodes(':visible', '[type="TRACTATE"]');
            for (var i = 0; i < terminiVisibili.length; i++) {
              that.nodiSelezionati.push(terminiVisibili[i].data().id);
            }
          },
          disabled: false
        },
        {
          id: 'nascondiTerminiPeculiari',
          content: 'nascondi termini peculiari',
          tooltipText: 'nascondi termini peculiari',
          selector: 'node[type="TRACTATE"]',
          onClickFunction: function (event) {
            let target = event.target;
            for (var i = 0; i < target.connectedEdges().targets().length; i++) {
              let nodoS = target.connectedEdges().targets()[i];
              if (nodoS.indegree() == 1) {
                nodoS.style("display", "none");
              }
            }
            that.nodiSelezionati = [];
            let terminiVisibili = that.cy.nodes(':visible', '[type="TRACTATE"]');
            for (var i = 0; i < terminiVisibili.length; i++) {
              that.nodiSelezionati.push(terminiVisibili[i].data().id);
            }
          },
          disabled: false
        },
        {
          id: 'nascondiTerminiCondivisiAltaRilevanza',
          content: 'nascondi termini condivisi ad alta rilevanza',
          tooltipText: 'nascondi termini condivisi ad alta rilevanza',
          selector: 'node[type="TRACTATE"]',
          onClickFunction: function (event) {
            let target = event.target;
            for (var i = 0; i < target.connectedEdges().targets().length; i++) {
              let nodoS = target.connectedEdges().targets()[i];
              if (nodoS.data().specific == false && nodoS.data().common == false) {
                nodoS.style("display", "none");
              }
            }
            that.nodiSelezionati = [];
            let terminiVisibili = that.cy.nodes(':visible', '[type="TRACTATE"]');
            for (var i = 0; i < terminiVisibili.length; i++) {
              that.nodiSelezionati.push(terminiVisibili[i].data().id);
            }
          },
          disabled: false
        },
        {
          id: 'nascondiTerminiCondivisiAltaFrequenza',
          content: 'nascondi termini condivisi ad alta frequenza',
          tooltipText: 'mostra termini condivisi ad alta frequenza',
          selector: 'node[type="TRACTATE"]',
          onClickFunction: function (event) {
            let target = event.target;
            for (var i = 0; i < target.connectedEdges().targets().length; i++) {
              let nodoS = target.connectedEdges().targets()[i];
              if (nodoS.data().common == true) {
                nodoS.style("display", "none");
              }
            }
            that.nodiSelezionati = [];
            let terminiVisibili = that.cy.nodes(':visible', '[type="TRACTATE"]');
            for (var i = 0; i < terminiVisibili.length; i++) {
              that.nodiSelezionati.push(terminiVisibili[i].data().id);
            }
          },
          disabled: false
        },
        {
          id: 'nascondiTrattato',
          content: 'nascondi trattato',
          tooltipText: 'nascondi trattato',
          selector: 'node[type="TRACTATE"]',
          onClickFunction: function (event) {
            let target = event.target;
            for (var i = 0; i < target.connectedEdges().targets().length; i++) {
              let nodoS = target.connectedEdges().targets()[i];
              nodoS.style("display", "none");
              target.style("display", "none");
            }
            that.nodiSelezionati = [];

            let terminiVisibili = that.cy.nodes(':visible', '[type="TRACTATE"]');
            for (var i = 0; i < terminiVisibili.length; i++) {
              that.nodiSelezionati.push(terminiVisibili[i].data().id);
            }
          },
          disabled: false
        },
        // context menu per termini
        {
          id: 'mostraTrattati',
          content: 'mostra Trattati',
          tooltipText: 'mostra Trattati',
          selector: 'node[type="TERM"][!specific]',
          onClickFunction: function (event) {
            let target = event.target;
            target.connectedEdges().sources().style("display", "element");
            target.connectedEdges().style("display", "element");
            let terminiVisibili = that.cy.nodes(':visible');
            for (var i = 0; i < terminiVisibili.length; i++) {
              that.nodiSelezionati.push(terminiVisibili[i].data().id);
            }
          },
          disabled: false
        },
        {
          id: 'mostraTrattato',
          content: 'mostra trattato',
          tooltipText: 'mostra trattato',
          selector: 'node[type="TERM"][?specific]',
          onClickFunction: function (event) {
            let target = event.target;
            target.connectedEdges().sources().style("display", "element");
            target.connectedEdges().style("display", "element");
            let terminiVisibili = that.cy.nodes(':visible');
            for (var i = 0; i < terminiVisibili.length; i++) {
              that.nodiSelezionati.push(terminiVisibili[i].data().id);
            }
          },
          disabled: false
        },
        {
          id: 'nascondiTermine',
          content: 'nascondi termine',
          tooltipText: 'nascondi termine',
          selector: 'node[type="TERM"]',
          onClickFunction: function (event) {
            let target = event.target;
            target.connectedEdges().target().style("display", "none");
            that.nodiSelezionati = [];
            let terminiVisibili = that.cy.nodes(':visible', '[type="TRACTATE"]');
            for (var i = 0; i < terminiVisibili.length; i++) {
              that.nodiSelezionati.push(terminiVisibili[i].data().id);
            }
          },
          disabled: false
        },
      ],
    };
    this.contextMenu = this.cy.contextMenus(this.ctxMenu);


    //estensione automove

    cytoscape.use(automove);
    // muovo il trattato e SOLO i suoi nodi figli che non sono in comune con gli altri trattati
    // Berakhot
    this.cy.automove({
      nodesMatching: this.cy.$('node[belongsTo=1]'),
      reposition: 'drag',
      dragWith: this.cy.$('#1')
    });
    // Ta'anit
    this.cy.automove({
      nodesMatching: this.cy.$('node[belongsTo=4]'),
      reposition: 'drag',
      dragWith: this.cy.$('#4')
    });
    // Betza
    this.cy.automove({
      nodesMatching: this.cy.$('node[belongsTo=6]'),
      reposition: 'drag',
      dragWith: this.cy.$('#6')
    });
    // Sukka
    this.cy.automove({
      nodesMatching: this.cy.$('node[belongsTo=8]'),
      reposition: 'drag',
      dragWith: this.cy.$('#8')
    });
    //Meghilla
    this.cy.automove({
      nodesMatching: this.cy.$('node[belongsTo=10]'),
      reposition: 'drag',
      dragWith: this.cy.$('#10')
    });
    //Qiddushin
    this.cy.automove({
      nodesMatching: this.cy.$('node[belongsTo=12]'),
      reposition: 'drag',
      dragWith: this.cy.$('#12')
    });
    // Rosh HaShananh
    this.cy.automove({
      nodesMatching: this.cy.$('node[belongsTo=14]'),
      reposition: 'drag',
      dragWith: this.cy.$('#14')
    });
    // Chaghiga
    this.cy.automove({
      nodesMatching: this.cy.$('node[belongsTo=16]'),
      reposition: 'drag',
      dragWith: this.cy.$('#16')
    });

    // funzione espandi/nascondi nodi
    // this.selezione = this.cy.$('node:selected');

    // layout per termini specifici
    this.cy.elements().style("display", "none");
    // funzione doppio clic su nodo
    this.cy.on('dblclick', 'node', function (evt) {
      this.selezione = evt.target.connectedEdges().targets();
      var node = evt.target.connectedEdges();
      //se nodo figlio è stato nascosto
      //prendo elem a 1 perchè 0 sarebbe il nodo stesso
      //controllo se i suoi figli sono nascosti
      if (node.targets().style("display") == "none" || evt.target.connectedEdges().sources().style("display") == "none") {
        that.layout.run();
        node.targets().style("display", "element");
        node.sources().style("display", "element");
        node.style("display", "element");
        let terminiVisibili = that.cy.nodes(':visible');
        for (var i = 0; i < terminiVisibili.length; i++) {
          that.nodiSelezionati.push(terminiVisibili[i].data().id);
        }
        that.centrare();
        // nascondi solo nodi specifici
      } else if (node.targets().style("display", "element")) {
        for (var i = 0; i < this.selezione.length; i++) {
          this.nodoS = this.selezione[i];
          if (this.nodoS.indegree() == 1) {
            this.nodoS.style("display", "none");
          }
          node.style("display", "element");
        }
        that.nodiSelezionati = [];
        let terminiVisibili = that.cy.nodes(':visible', '[type="TRACTATE"]');
        for (var i = 0; i < terminiVisibili.length; i++) {
          that.nodiSelezionati.push(terminiVisibili[i].data().id);
        }
        that.centrare();
      } else {
        node.targets().style("display", "none");
        // node.sources().style("display", "none");
        that.nodiSelezionati = [];
        // node.removeClass('highlight');
        that.layout.stop();
      }
    });


    // visualizza panel info nodo cliccato
    this.cy.on('tap', '*', function (evt) {

      const panel = document.getElementById('panel');
      var node = evt.target;
      var nodeConnectedEdges = node.connectedEdges();
      var termini = evt.target.connectedEdges().sort(function (a, b) {
        var magg = a.data.weight;
        var min = b.data.weight;
        return magg > min
      });

      var tuttiTermini = termini.targets("node[type='TERM']").map(function (ele) {
        if (ele.data().specific == true && ele.data().common == false) {
          return `<br><span style="color:#CA5E53;"> ` + ele.data().label + `</span> `
        }
        if (ele.data().specific == false && ele.data().common == false) {
          return `<br><span style="color:#3F9953;"> ` + ele.data().label + `</span> `
        }
        if (ele.data().specific == false && ele.data().common == true) {
          return `<br><span style="color:#6666ff;"> ` + ele.data().label + `</span> `
        }
      });

      var edgeTermini = termini.map(function (ele) {
        if (ele.targets().data().specific == true && ele.targets().data().common == false) {
          return `<em style="color:#CA5E53;">[` + ele.data().noOfOccur + `]</em>`
        }
        if (ele.targets().data().specific == false && ele.targets().data().common == false) {
          return `<em style="color:#3F9953;">[` + ele.data().noOfOccur + `]</em>`
        }
        if (ele.targets().data().specific == false && ele.targets().data().common == true) {
          return `<em style="color:#6666ff;">[` + ele.data().noOfOccur + `]</em>`
        }
      });

      var edgeTerminiO = termini.map(function (ele) {
        return `<em>[` + ele.data().noOfOccur + `]</em>`
      });

      var trattati = termini.sources().map(function (ele) {
        return `<br>` + ele.data().label
      });

      //stampo i due array vicini togliendo virgola finale Termini-Occurrence
      let zipTerminiOccurrence = `<span >` + tuttiTermini.map((x, i) => [x, edgeTermini[i]].join(' ')).join(' ') + `</span>`;

      //stampo i due array vicini togliendo virgola finale Trattati Occurrence
      let zipTrattatiOccurrence = `<span >` + trattati.map((x, i) => [x, edgeTerminiO[i]].join(' ')).join(' ') + `</span>`;

      // DA FIXARE
      if (panel.style.display === 'none' || this.currentEle !== node.data()) {   //se ho cliccato sullo stesso elemento di prima per prendere solo id node.data().id
        panel.style.display = 'block';
        this.currentEle = node.data();
        // PANEL BOX TRATTATI
        if (this.currentEle.type == "TRACTATE") {
          panel.innerHTML = `<p><b>Trattato:</b></br> ${this.currentEle.label}</p>
          <p><b>Termini</b><em> [#occorrenze] </em><b>: </b></br><small>(in ordine decrescente di tf-idf)</small> ${zipTerminiOccurrence}</p>`
        }
        // PANEL BOX TERMINE SPECIFICO
        if (this.currentEle.type == "TERM" && this.currentEle.specific == true) {
          panel.innerHTML = `<p><b>Termine:</b><br> ${this.currentEle.label} </p>
          <p><b>contenuto in:</b><em> [#occorrenze] </em><b>:</b> ${zipTrattatiOccurrence}</p>`
        }

        // PANEL BOX TERMINE CONDIVISO
        if (this.currentEle.type == "TERM" && this.currentEle.specific == false) {
          panel.innerHTML = `<p><b>Termine:</b><br> ${this.currentEle.label} </p>
          <p><b>contenuto in:</b><em> [#occorrenze] </em><b>:</b> ${zipTrattatiOccurrence}</p>`
        }



        // se clicco su evt target tolgo classe highlight da nodi precedenti
        that.cy.nodes(':visible').forEach(nodiSelezionati => {

          if (nodiSelezionati !== evt.target) {
            nodiSelezionati.removeClass('highlight');
            nodiSelezionati.connectedEdges().targets().removeClass('highlight');
            nodiSelezionati.connectedEdges().removeClass('highlight');
            console.log("tolgo classe highlight dai nodi non evt.targe");
          }
        })
        nodeConnectedEdges.targets().addClass('highlight');
        nodeConnectedEdges.sources().addClass('highlight');
        nodeConnectedEdges.addClass('highlight');
      } else {
        panel.style.display = 'none';
        this.currentEle = null; //resetto il valore 
        nodeConnectedEdges.targets().removeClass('highlight');
        nodeConnectedEdges.sources().removeClass('highlight');
        nodeConnectedEdges.removeClass('highlight');
      }
    });

    // chiudo panel se clicco su background
    this.cy.on('tap', function (evt) {
      var node = evt.target;
      const panel = document.getElementById('panel');
      if (node === this) { //this è il core
        console.log('tap on cy');
        // that.cy.nodes(':visible').removeClass('highlight');
        // that.cy.edges(':visible').removeClass('highlight');
        that.layout.stop();
        console.log("stop layout");
        //tolgo classe highlight quando chiudo panel al clic sullo sfondo 
        // if (that.cy.nodes(':visible').hasClass('highlight')) {
        that.cy.nodes(':visible').removeClass('highlight');
        that.cy.edges(':visible').removeClass('highlight');
        //   console.log("3 rimuovo classe");
        // }
        if (panel.style.display === 'block') {
          that.layout.stop();
          panel.style.display = 'none';
        }

      }
    });


    //  recupero info edge
    this.cy.on('tap', 'edge', function (evt) {
      const panel = document.getElementById('panel');
      const node = evt.target;
      // visualizzo label del source dell'edge cliccato
      var labelSource = node.sources().data().label;
      // visualizzo label del target dell'edge cliccato
      var labelTarget = node.targets().data().label;
      if (this.currentEle !== node.data().id) {   //se ho cliccato sullo stesso elemento di prima per prendere solo id node.data().id
        this.currentEle = node.data();
        panel.innerHTML = ` <p><b>Termine:</b></br> ${labelTarget} </p> 
        <p><b>contenuto in:</b></br> ${labelSource} </p> 
        <p><b>#occorrenze:</b></br> ${this.currentEle.noOfOccur} </p>`; //stringhe con variabili all'interno, quello inserito tra $ e par graffa deve essere variabile o espressione ecc.
        panel.style.display = 'block';
      } else {
        panel.style.display = 'none';
        this.currentEle = null; //resetto il valore 
      }
    });
  }

  // mostro nodo corrispondente a quello selezionato da colonna filtro
  cliccato(trat) {
    this.sharedTermsShown = false;
    this.clicked = false;
    if (this.cy.getElementById(trat.data.id).style('display') == 'none') {
      this.cy.getElementById(trat.data.id).style('display', 'element');
      console.log("elemento cliccato è " + trat.data.id);
    } else {
      this.cy.getElementById(trat.data.id).flashClass('highlight', 1000);
      this.cy.getElementById(trat.data.id).style('z-index', '1');
    }
    this.nodoCliccato = trat.data.id;
    this.nodiSelezionati.push(this.nodoCliccato);
    this.centrare();

  }


  mostraNodi() {
    this.sharedTermsShown = true;
    this.specificTermsShown = true;
    this.cy.elements().style("display", "element");
    // this.cy.fit();
    // this.cy.layout(this.defaults).run();
    this.layout.run();
    this.zoomCurrent = this.cy.zoom();
    let terminiVisibili = this.cy.nodes(':visible');
    for (var i = 0; i < terminiVisibili.length; i++) {
      this.nodiSelezionati.push(terminiVisibili[i].data().id);
    }
  }

  nascondiNodi() {
    this.sharedTermsShown = false;
    this.specificTermsShown = false;
    this.cy.elements().style("display", "none");
    this.cy.elements().removeClass('highlight');
    this.clicked = true;
    this.nodiSelezionati = []; //tolgo l'highlight su tutti i nodi selezionati nella lista di sx
    this.searchText = ''  //svuoto input search
    const panel = document.getElementById('panel');
    if (panel.style.display === 'block') {
      panel.style.display = 'none';
    }
    // per resettare posizione iniziale dei nodi
    window.location.reload();
  }

  terminiCondivisi() {
    const t0 = performance.now()
    if (this.sharedTermsShown) {
      //sono visibili quindi li nascondo
      var sharedNodes = this.cy.nodes(':visible').filter("[type='TRACTATE']").connectedEdges().targets("node[!specific][!common]");
      sharedNodes.style("display", "none");
      sharedNodes.connectedEdges().style("display", "none");
      this.sharedTermsShown = false;
      this.nodiSelezionati = [];
      let terminiVisibili = this.cy.nodes(':visible');
      for (var i = 0; i < terminiVisibili.length; i++) {
        this.nodiSelezionati.push(terminiVisibili[i].data().id);
      }
    } else {
      this.layout.run();
      //sono nascosti quindi li visualizzo
      //console.log("All terms:             " + this.cy.nodes().filter("[type = 'TERM']").length);
      //console.log("Hidden terms:          " + this.cy.nodes(':hidden').filter("[type = 'TERM']").length);
      //console.log("Hidden specific terms: " + this.cy.nodes(':hidden').filter("[type = 'TERM'][?specific]").length);
      //console.log("Hidden shared terms:   " + this.cy.nodes(':hidden').filter("[type = 'TERM'][!specific]").length);
      //seleziono i nodi termine che sono nascosti
      this.cy.nodes(':hidden').filter("[type='TERM'][!specific][!common]").forEach(termNode => {
        //verifico se il nodo termine (termNode) e' collegato ad almeno di 2 nodi trattato per decidere di visualizzarlo
        //console.log(element.id() + " LEN: " + (this.cy.nodes(':visible', "[type='TRACTATE']").connectedEdges().targets("node[id='" + element.id()+"']")).length);
        // insieme dei NodiTrattato Visibili => archi uscenti che puntano a => termNode => archi uscenti da termNone => insieme dei NodiTrattato Visibili 
        var selectedNode = this.cy.nodes(':visible').filter("[type='TRACTATE']").connectedEdges().targets('node[id = "' + termNode.id() + '"]');
        if (selectedNode.connectedEdges().sources(':visible').filter("[type='TRACTATE']").length > 1) {
          //se termNode e' collegato ad almeno 2 nodi trattato lo visualizzo e visualizzo gli archi che lo collegano a questi trattati.
          selectedNode.style("display", "element");
          selectedNode.connectedEdges().style("display", "element");
        }
      });
      this.sharedTermsShown = true;
      //console.log("Termini nascosti dopo: " + this.cy.nodes(':hidden', "![type='TRACTATE']").size());
      const t1 = performance.now()

      let terminiVisibili = this.cy.nodes(':visible');
      for (var i = 0; i < terminiVisibili.length; i++) {
        this.nodiSelezionati.push(terminiVisibili[i].data().id);
      }

      if (this.cy.nodes(':visible').filter("[type='TRACTATE']").connectedEdges().targets(':visible', "node[!specific]").toArray().length === 0) {
        alert("nessun termine condiviso con i trattati visibili!");
      }
      this.centrare();

      console.log("Call to terminiCondivisi took " + (t1 - t0) + " milliseconds. ")
    }
  }

  terminiComuni() {
    if (this.sharedTermsShown) {
      //sono visibili quindi li nascondo
      var sharedNodes = this.cy.nodes(':visible').filter("[type='TRACTATE']").connectedEdges().targets("node[?common]");
      sharedNodes.style("display", "none");
      sharedNodes.connectedEdges().style("display", "none");
      this.sharedTermsShown = false;
      this.nodiSelezionati = [];
      let terminiVisibili = this.cy.nodes(':visible');
      for (var i = 0; i < terminiVisibili.length; i++) {
        this.nodiSelezionati.push(terminiVisibili[i].data().id);
      }
    } else {
      this.layout.run();
      //seleziono i nodi termine che sono nascosti
      this.cy.nodes(':hidden').filter("[type='TERM'][?common]").forEach(termNode => {
        var selectedNode = this.cy.nodes(':visible').filter("[type='TRACTATE']").connectedEdges().targets('node[id = "' + termNode.id() + '"]');
        if (selectedNode.connectedEdges().sources(':visible').filter("[type='TRACTATE']").length >= 1) {
          //se termNode e' collegato ad almeno 2 nodi trattato lo visualizzo e visualizzo gli archi che lo collegano a questi trattati.
          selectedNode.style("display", "element");
          selectedNode.connectedEdges().style("display", "element");
        }
      });
      this.sharedTermsShown = true;
      let terminiVisibili = this.cy.nodes(':visible');
      for (var i = 0; i < terminiVisibili.length; i++) {
        this.nodiSelezionati.push(terminiVisibili[i].data().id);
      }

      if (this.cy.nodes(':visible').filter("[type='TRACTATE']").connectedEdges().targets(':visible', "node[?common]").toArray().length === 0) {
        alert("nessun termine comune con i trattati visibili!");
      }
      this.centrare();
    }
  }

  terminiSpecifici() {
    var specificNodes = this.cy.nodes(':visible').filter("[type='TRACTATE']").connectedEdges().targets("node[?specific]");
    if (specificNodes.style("display") == "element") {
      specificNodes.style("display", "none");
      specificNodes.connectedEdges().style("display", "none");
      this.cy.nodes(':visible', "[type='TRACTATE']").style("display", "element");
      this.nodiSelezionati = [];
      let terminiVisibili = this.cy.nodes(':visible');
      for (var i = 0; i < terminiVisibili.length; i++) {
        console.log("termini visibili " + terminiVisibili.length);
        this.nodiSelezionati.push(terminiVisibili[i].data().id);
      }
      // this.cy.fit();
    } else {
      this.layout.run();
      specificNodes.style("display", "element");
      specificNodes.connectedEdges().style("display", "element");
      this.cy.nodes(':visible', "[type='TRACTATE']").style("display", "element");
      let terminiVisibili = this.cy.nodes(':visible');
      for (var i = 0; i < terminiVisibili.length; i++) {
        this.nodiSelezionati.push(terminiVisibili[i].data().id);
      }
      // this.cy.fit();
      this.centrare();
    }
  }

  centrare(): void {
    this.cy.fit();
    this.zoomCurrent = this.cy.zoom();
  }


  zoomReset(): void {
    this.cy.zoom(0.5);
    this.cy.center();
  }

  zoomIn(): void {
    if (this.zoomCurrent < this.cy.maxZoom()) {
      this.zoomCurrent += this.zoomStep;
      this.cy.zoom({
        level: this.zoomCurrent,
        //renderedPosition: { x: 0, y: 0 }
      });
      //this.cy.center();
    }
  }

  zoomOut(): void {
    if (this.zoomCurrent > this.cy.minZoom()) {
      this.zoomCurrent -= this.zoomStep;
      this.cy.zoom({
        level: this.zoomCurrent,
        // renderedPosition: { x: 0, y: 0 }
      });
      //this.cy.center();
    }
  }

  // colore colonna di sinistra : rosso per termini specifici, verde termini condivisi, blu termini frequenti
  specific(specific, common) {
    if (specific == true && common == false) {
      return '#CA5E53';
    }
    if (specific == false && common == false) {
      return '#3F9953';
    }
    if (specific == false && common == true) {
      return '#6666ff';
    }
  }
}


